
document.addEventListener("DOMContentLoaded", function () {
    const carousel = document.getElementById("videoCarousel");
    const leftArrow = document.querySelector(".carousel-arrow.left");
    const rightArrow = document.querySelector(".carousel-arrow.right");
    const dotsContainer = document.getElementById("carouselDots");
    const modal = document.getElementById("videoModal");
    const modalVideo = document.getElementById("modalVideo");
    const playPauseBtn = document.getElementById("playPauseBtn");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");
    const closeBtn = document.querySelector(".modal-close");
    const productInfoContainer = document.getElementById("videoProductInfo");
  
    const items = carousel.querySelectorAll(".video-item");
    const hlsSupported = Hls.isSupported();
    const hlsInstances = new Map();
  
    function loadVideoWithHls(videoElement, src, key) {
      if (src.endsWith(".m3u8")) {
        if (hlsSupported) {
          const hls = new Hls();
          hls.loadSource(src);
          hls.attachMedia(videoElement);
          hls.on(Hls.Events.ERROR, function (event, data) {
            console.error("HLS error:", data);
          });
          hlsInstances.set(key, hls);
        } else if (videoElement.canPlayType("application/vnd.apple.mpegurl")) {
          videoElement.src = src;
        } else {
          console.warn("Este navegador no soporta HLS");
        }
      } else {
        videoElement.src = src;
      }
    }
  
    const videosData = Array.from(items).map((item) => {
      const video = item.querySelector("video");
      const title = item.querySelector(".video-title")?.textContent || "";
      const src = video?.getAttribute("src") || "";
  
      const product = {
        title: item.dataset.productTitle || '',
        price: item.dataset.productPrice || '',
        url: item.dataset.productUrl || '',
        image: item.dataset.productImage || '',
        variant: item.dataset.productVariant || '',
        handle: item.dataset.productHandle || ''
      };
  
      return { videoElement: video, src, title, product };
    });
  
    videosData.forEach(({ videoElement, src }, i) => {
      if (src) loadVideoWithHls(videoElement, src, `carousel-${i}`);
    });
  
    let currentVideoIndex = 0;
    const isMobile = window.innerWidth <= 768;
    const itemsPerView = isMobile ? 2 : 5;
    const totalPages = Math.ceil(items.length / itemsPerView);
    let currentPage = 0;
  
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement("span");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => {
        const scrollAmount = items[0].offsetWidth * itemsPerView * i + 12 * (itemsPerView - 1) * i;
        carousel.scrollTo({ left: scrollAmount, behavior: "smooth" });
      });
      dotsContainer.appendChild(dot);
    }
  
    const updateDots = () => {
      const scrollLeft = carousel.scrollLeft;
      const itemWidth = items[0].offsetWidth + 12;
      const index = Math.round(scrollLeft / itemWidth);
      const newPage = Math.floor(index / itemsPerView);
      if (newPage !== currentPage && newPage >= 0 && newPage < totalPages) {
        currentPage = newPage;
        dotsContainer.querySelectorAll(".dot").forEach((dot, i) => {
          dot.classList.toggle("active", i === currentPage);
        });
      }
    };
  
    carousel.addEventListener("scroll", () => {
      window.requestAnimationFrame(updateDots);
    });
  
    carousel.querySelectorAll("video").forEach((video) => {
      video.addEventListener("mouseenter", () => {
        video.play().catch(() => { });
      });
      video.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  
    function openModal(index) {
      currentVideoIndex = index;
      const { src, product } = videosData[index];
  
      modalVideo.pause();
      modalVideo.removeAttribute("src");
      modalVideo.load();
      productInfoContainer.innerHTML = "";
  
      if (window.hlsInstance) {
        window.hlsInstance.destroy();
        window.hlsInstance = null;
      }
  
      if (src.endsWith(".m3u8")) {
        if (hlsSupported) {
          window.hlsInstance = new Hls();
          window.hlsInstance.loadSource(src);
          window.hlsInstance.attachMedia(modalVideo);
          window.hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => {
            modalVideo.play().catch(() => { });
          });
        } else if (modalVideo.canPlayType("application/vnd.apple.mpegurl")) {
          modalVideo.src = src;
          modalVideo.play().catch(() => { });
        }
      } else {
        modalVideo.src = src;
        modalVideo.play().catch(() => { });
      }
  
      modal.classList.add("active");
      document.body.style.overflow = "hidden";
      playPauseBtn.classList.add("hidden");
      setTimeout(() => playPauseBtn.classList.remove("hidden"), 1000);
  
      if (product && product.title && product.variant) {
        let variants = [];
        try {
          const rawVariants = items[index].dataset.productVariants;
          console.log({ rawVariants })
          variants = JSON.parse(rawVariants);
        } catch (e) {
          console.warn("Variants error parse", e);
        }
        const html = `
        <div class="product-details">
              <img src="${product.image}" alt="${product.title}">
              <div class="product-price">
              <div class="product-title">${product.title}</div>
                ${product.price}
                ${variants.length > 1
            ? `
                    <select id="variantSelect" style="margin-top: 6px; width: 100%; padding: 6px; border-radius: 6px;">
                      ${variants
              .map(
                (v) => `
                        <option value="${v.id}" ${!v.available ? "disabled" : ""}>
                          ${v.title}${!v.available ? " (Sold out)" : ""}
                        </option>`
              )
              .join("")}
                    </select>
        `
            : `<input type="hidden" id="variantSelect" value="${product.variant}">`
          }
              </div>
            </div>
    
            <button class="buy-now-btn" onclick="addToCart('${product.variant}')">
              Add to Cart
            </button>
          `;
        productInfoContainer.innerHTML = html;
        const addBtn = document.querySelector(".buy-now-btn");
        addBtn.addEventListener("click", () => {
          const selectedVariant = document.getElementById("variantSelect").value;
          addToCart(selectedVariant);
        });
      }
    }
  
    items.forEach((item, index) => {
      item.addEventListener("click", () => openModal(index));
    });
  
    function closeModal() {
      modal.classList.remove("active");
      document.body.style.overflow = "auto";
      modalVideo.pause();
      modalVideo.currentTime = 0;
      if (window.hlsInstance) {
        window.hlsInstance.destroy();
        window.hlsInstance = null;
      }
    }
    function priceFormat(price, locale = 'en-US', currency = 'USD') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(price);
    }
    function nextVideo() {
      if (currentVideoIndex < videosData.length - 1) {
        openModal(currentVideoIndex + 1);
      }
    }
  
    function prevVideo() {
      if (currentVideoIndex > 0) {
        openModal(currentVideoIndex - 1);
      }
    }
  
    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  
    playPauseBtn.addEventListener("click", () => {
      if (modalVideo.paused) {
            playPauseBtn.style.opacity = '1'
        modalVideo.play();
        playPauseBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pause-icon lucide-pause"><rect x="14" y="4" width="4" height="16" rx="1"/><rect x="6" y="4" width="4" height="16" rx="1"/></svg>`;
        setTimeout(() => {
            playPauseBtn.style.opacity = '0'
        }, 1000);
      } else {
        modalVideo.pause();
            playPauseBtn.style.opacity = '1'
        
        playPauseBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-play-icon lucide-play"><polygon points="6 3 20 12 6 21 6 3"/></svg>`
        setTimeout(() => {
            playPauseBtn.style.opacity = '0'
        }, 1000);
      }
    });
  
    nextBtn.addEventListener("click", nextVideo);
    prevBtn.addEventListener("click", prevVideo);
  
    document.addEventListener("keydown", (e) => {
      if (modal.classList.contains("active")) {
        switch (e.key) {
          case "Escape": closeModal(); break;
          case "ArrowLeft": prevVideo(); break;
          case "ArrowRight": nextVideo(); break;
          case " ": e.preventDefault(); playPauseBtn.click(); break;
        }
      }
    });
  
    let wheelTimeout;
    modal.addEventListener("wheel", (e) => {
      if (modal.classList.contains("active")) {
        e.preventDefault();
        clearTimeout(wheelTimeout);
        wheelTimeout = setTimeout(() => {
          if (e.deltaY > 0) {
            nextVideo();
          } else {
            prevVideo();
          }
        }, 100);
      }
    });
  
    let modalIsDragging = false;
    let modalStartX = 0;
    let modalStartY = 0;
    let modalEndX = 0;
    let modalEndY = 0;
  
    modal.addEventListener("mousedown", (e) => {
      if (modal.classList.contains("active") && e.target === modal) {
        modalIsDragging = true;
        modalStartX = e.clientX;
        modalStartY = e.clientY;
        modal.style.cursor = "grabbing";
      }
    });
  
    modal.addEventListener("mousemove", (e) => {
      if (modalIsDragging) {
        modalEndX = e.clientX;
        modalEndY = e.clientY;
      }
    });
  
    modal.addEventListener("mouseup", (e) => {
      if (modalIsDragging) {
        modalIsDragging = false;
        modal.style.cursor = "default";
  
        const deltaX = modalEndX - modalStartX;
        const deltaY = modalEndY - modalStartY;
        const swipeThreshold = 50;
  
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeThreshold) {
          if (deltaX > 0) {
            prevVideo();
          } else {
            nextVideo();
          }
        }
  
        // Verificar si es un swipe vertical
        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > swipeThreshold) {
          if (deltaY > 0) {
            nextVideo();
          } else {
            prevVideo();
          }
        }
      }
    });
  
    modal.addEventListener("mouseleave", () => {
      if (modalIsDragging) {
        modalIsDragging = false;
        modal.style.cursor = "default";
      }
    });
    let isDragging = false;
    let startX, scrollLeft;
  
    carousel.addEventListener("mousedown", (e) => {
      isDragging = true;
      carousel.classList.add("dragging");
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
  
    carousel.addEventListener("mouseleave", () => {
      isDragging = false;
      carousel.classList.remove("dragging");
    });
  
    carousel.addEventListener("mouseup", () => {
      isDragging = false;
      carousel.classList.remove("dragging");
    });
  
    carousel.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 1.5;
      carousel.scrollLeft = scrollLeft - walk;
    });
  
    const scrollAmount = items[0].offsetWidth * itemsPerView + 12 * (itemsPerView - 1);
    leftArrow.addEventListener("click", () => {
      carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
    rightArrow.addEventListener("click", () => {
      carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
  
    let touchStartY = 0;
    let touchEndY = 0;
  
    modal.addEventListener("touchstart", (e) => {
      touchStartY = e.changedTouches[0].screenY;
    });
  
    modal.addEventListener("touchend", (e) => {
      touchEndY = e.changedTouches[0].screenY;
      handleSwipeGesture();
    });
  
    function handleSwipeGesture() {
      const swipeThreshold = 50;
      if (touchStartY - touchEndY > swipeThreshold) nextVideo();
      else if (touchEndY - touchStartY > swipeThreshold) prevVideo();
    }
  });
  
  function addToCart(variantId) {
    const button = document.querySelector('.buy-now-btn');
  
    if (!variantId || variantId === 'undefined' || variantId === '') {
      console.error('Error: Variant ID is missing');
      alert('Error: Product variant not found');
      return;
    }
  
  
    fetch(`/cart/add?id=${variantId}&quantity=1`, {
      method: 'GET',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(data => {
        updateCartCount();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      })
      .finally(() => {
        closeModal()
        setTimeout(() => {
          if (button) {
            button.disabled = false;
            button.classList.remove('loading');
            button.textContent = 'Add to Cart';
            button.style.background = 'rgb(154, 79, 35)';
          }
        }, 2000);
      });
  }
  
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }